<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import GroupParticipantName from '../GroupParticipantName.vue';
import { useMessageContext } from '../provider.js';

const { attachments } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});
</script>

<template>
  <BaseBubble class="bg-transparent" data-bubble-name="audio">
    <div class="flex flex-col gap-1 px-2 pt-2">
      <GroupParticipantName />
      <AudioChip
        :attachment="attachment"
        class="text-n-slate-12 skip-context-menu"
      />
    </div>
  </BaseBubble>
</template>
